module.exports = __webpack_public_path__ + "static/media/GrainProcessingHendersonvilleNC2006PencilandCoffeeonvintagepaper.e3ac10e8.webp";